import { apiConfig, createAxiosServiceInstance } from '../api';
import {
  AMLS_COMMON,
  AMLS_NS_IAD,
  AMLS_NS_COMMON
} from '../../pages/constants/globalConstants';

const axios = createAxiosServiceInstance();

const baseURL = `${apiConfig.serviceApi}`;
const alertDetailsURL = `${baseURL}${AMLS_NS_COMMON}/alerts`;
const watchListBaseUrl = `${baseURL}${AMLS_NS_IAD}/watchlist`;
const whiteListBaseUrl = `${baseURL}${AMLS_NS_IAD}/whitelist`;
const runInstanceBaseUrl = `${baseURL}${AMLS_NS_IAD}/runInstance`;
const CustomerTypeBaseUrl = `${baseURL}${AMLS_NS_IAD}/customerType`;

const saved_token = (localStorage && localStorage.getItem('id_token')) || '';

const headers = {
  'Content-Type': 'application/json'
};

export async function getAlertDetailsData(payload) {
  const { id } = payload;
  const url = alertDetailsURL + '/' + id + '/hits';

  return await axios.get(url, { headers }).then((res) => {
    return { ...res.data };
  });
}

export async function getFurtherInformation(payload) {
  const { hitId } = payload;
  const url = `${baseURL}${AMLS_NS_COMMON}/alerts/hits/${hitId}`;

  return await axios.get(url, { headers }).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.msg ?? 'Error fetching further information');
    }
    return { ...res.data };
  });
}

export async function getRelatedPartyInfo(payload) {
  const { watchlistId } = payload;
  const url = `${baseURL}${AMLS_NS_IAD}/watchlist/info/${watchlistId}`;

  return await axios.get(url, { headers }).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.msg ?? 'Error fetching watchlist details');
    }

    return { ...res.data };
  });
}

export async function getNSRunInstanceResultListService(payload) {
  const { limit, offset } = payload;
  const params = {
    ...payload,
    limit: limit || 5,
    offset: offset || 0
  };

  return await axios
    .get(`${baseURL}${AMLS_COMMON}/alerts`, { headers, params })
    .then((res) => {
      return {
        ...res.data
      };
    });
}

export async function postHitsUserFeedbackService(payload) {
  const URL = `${baseURL}${AMLS_NS_COMMON}/alerts/${payload.alertId}/hits/${payload.hitId}?watchlistId=${payload.watchlistId}&alertSourceId=${payload.alertSourceId}&reviewFeedback=${payload.newAlertStatus}`;
  return await axios.put(URL, headers).then((res) => {
    if (res.status !== 200) {
      throw new Error('Failed to fetch alerts');
    }

    return {
      ...res.data
    };
  });
}

/***
 * Run Instance Summary
 ***/
export async function getNSRunInstanceSummaryService(payload) {
  const { limit, offset, id, sourceId = '' } = payload;
  let params = {};
  let URL = `${baseURL}${AMLS_NS_IAD}/runInstance/all/${sourceId}`;
  if (id) {
    params = {};
    URL = `${baseURL}${AMLS_NS_IAD}/runInstance`;
    URL += '/' + id;
  } else {
    params = {
      limit: limit || 5,
      offset: offset || 0
    };
  }

  return await axios
    .get(URL, {
      headers,
      params
    })
    .then((res) => {
      return {
        ...res.data
      };
    })
    .catch((err) => {
      throw err;
    });
}

export async function getNSRIWatchListService(payload) {
  headers['Authorization'] = `${saved_token}`;
  return await axios.get(watchListBaseUrl, { headers }).then((res) => {
    return {
      ...res.data
    };
  });
}

/** WatchList Coverage and Reports Service */
export async function getNSRIWatchListCoverageReportsService(payload) {
  headers['Authorization'] = `${saved_token}`;
  return await axios
    .get(`${watchListBaseUrl}/${payload.id}`, { headers })
    .then((res) => {
      return {
        ...res.data
      };
    });
}

export async function getNSRIWhiteListService() {
  headers['Authorization'] = `${saved_token}`;
  return axios.get(whiteListBaseUrl, { headers }).then((res) => {
    return {
      ...res.data
    };
  });
}

/**
 *  Deploy To Production
 **/
export async function postDeployToProductionService(payload) {
  const URL = `${baseURL}${AMLS_NS_IAD}/runInstance/promoteToChampion`;
  return await axios.post(URL, payload, { headers }).then((res) => {
    return res;
  });
}

export async function saveRunInstanceService(payload) {
  return await axios
    .post(runInstanceBaseUrl, payload, { headers })
    .then((res) => {
      return res;
    });
}

export async function postRunRunInstanceService(payload) {
  const URL = `${runInstanceBaseUrl}/${payload.id}/execution`;
  return await axios.post(URL, {}, { headers }).then((res) => {
    return res;
  });
}

export async function getRunInstanceViewExecutionService(payload) {
  const params = {
    limit: payload.limit || 5,
    offset: payload.offset || 0
  };

  const URL = `${runInstanceBaseUrl}/${payload.id}/executions`;
  return axios.get(URL, { headers, params }).then((res) => {
    return res;
  });
}

export async function getCustomerTypeService() {
  return await axios.get(CustomerTypeBaseUrl, { headers }).then((res) => {
    return res.data;
  });
}

export async function postCustomerTypeService(payload) {
  const { data } = payload;
  return await axios
    .post(CustomerTypeBaseUrl, data, { headers })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export async function putCustomerTypeService(payload) {
  const { data } = payload;
  const { id, name } = data;
  const url = `${CustomerTypeBaseUrl}/${id}`; // Append the ID to the base URL
  try {
    const response = await axios.put(url, { name }, { headers }); // Pass 'name' as a separate JSON object
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function deleteCustomerTypeService(payload) {
  const { id } = payload;
  const trimmedId = id.trim(); // Remove spaces from the id
  const url = `${CustomerTypeBaseUrl}/${trimmedId}`;

  return await axios
    .delete(url, {
      headers
    })
    .then((res) => {
      return {
        res
      };
    })
    .catch((err) => {
      throw err;
    });
}
